import { z } from 'zod';

import type {
  UpdateShipmentHoldingUnitEvidenceRequest,
  UpdateShipmentHoldingUnitEvidenceResponse,
} from './update-shipment-holding-unit-evidence.dto.js';
import {
  ShipmentHeaderSchema,
  validateShipmentSourceEvidencePair,
} from './shipments-shared.schema.js';

export const UpdateShipmentHoldingUnitEvidenceRequestSchema: z.ZodType<UpdateShipmentHoldingUnitEvidenceRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    sourceLoadSessionId: z.uuid().nullable().optional(),
    sourceLoadSessionGroupId: z.uuid().nullable().optional(),
  })
  .strict()
  .superRefine(validateShipmentSourceEvidencePair);

export const UpdateShipmentHoldingUnitEvidenceResponseSchema: z.ZodType<UpdateShipmentHoldingUnitEvidenceResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
  })
  .strict();
